import { render, staticRenderFns } from "./Programme.vue?vue&type=template&id=23e93c8f&scoped=true&"
import script from "./Programme.vue?vue&type=script&lang=ts&"
export * from "./Programme.vue?vue&type=script&lang=ts&"
import style0 from "./Programme.vue?vue&type=style&index=0&id=23e93c8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e93c8f",
  null
  
)

export default component.exports